import React from 'react';
import { Loader } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/elements/loader.less';

export default Loader;
